import { Link } from 'react-router-dom';
import { Container, Button } from '@/components/ui';
import { ROUTES } from '@/config/constants';

export function NotFoundPage() {
  return (
    <Container className="flex min-h-[70vh] flex-col items-center justify-center text-center">
      <h1 className="text-6xl font-black text-hi">404</h1>
      <p className="mt-2 text-mid">This page wandered off.</p>
      <Link to={ROUTES.home} className="mt-6">
        <Button>Back home</Button>
      </Link>
    </Container>
  );
}
